import styled, { css } from 'styled-components';
import { RadioCardItemProps } from '.';
import { construirSombra } from '@/styles/theme';

export const Container = styled.div<RadioCardItemProps>`
  display: flex;
  flex-direction: row;

  ${({ theme, $useRadioIcon, $iconPosition }) => {
    if ($useRadioIcon) {
      if ($iconPosition === 'end') {
        return css`
          align-items: center;
          justify-content: space-between;
        `;
      }

      return css`
        align-items: center;
        gap: ${theme.spacing[2]}px;
      `;
    }

    return css`
      align-items: start;
      justify-content: center;
    `;
  }}

  background-color: ${({ theme, $variant }) => {
    if ($variant === 'outline') return 'none';
    return theme.tokens.colors.surface;
  }};

  padding: ${({ theme, $size }) => theme.spacing[$size < 2 ? 3 : $size + 2]}px;

  border: 2px solid ${({ theme }) => theme.colors.neutral.neutral_alpha['6']};
  border-radius: ${({ theme, $size }) => theme.radius[$size < 3 ? 3 : $size]}px;

  ${({ $variant }) => {
    if ($variant === 'classic')
      return css`
        box-shadow: ${construirSombra('shadow_2')};
      `;
  }}

  &:hover {
    ${({ $variant, $state }) => {
      if ($state !== 'checked')
        return css`
          cursor: pointer;
          border-color: ${({ theme }) =>
            theme.colors.neutral.neutral_alpha['6']};
        `;
      if ($variant === 'classic')
        return css`
          box-shadow: ${construirSombra('shadow_3')};
        `;
    }}
  }

  ${({ theme, $state, $variant, $color }) => {
    if ($state === 'checked')
      return css`
        box-shadow: none;
        background-color: ${$variant !== 'outline'
          ? theme.tokens.colors.accent_surface
          : 'transparent'};
        background: linear-gradient(180deg, ${theme.panel.solid} 0%, #000 100%),
          #fff;
        border: 2px solid
          ${$color === 'accent'
            ? theme.colors.accent.accent[8]
            : theme.tokens.colors.white_contrast};
      `;
  }}
`;
